// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteProperty_deleteButton__2mceA"};